import { FC } from 'react';
import { ProjectFeaturesType } from './ProjectFeaturesTypes.ts';
import styles from './ProjectFeatures.module.scss';

/**
 * Props for the ProjectFeatures component.
 */
interface ProjectFeaturesProps {
    features: ProjectFeaturesType;
}

const ProjectFeatures: FC<ProjectFeaturesProps> = (props) => {
    const { 
        features 
    } = props;

    const {
        title,
        items
    } = features;

    return (
        <div
            className={styles.features}
        >
            <h4
                className={styles.featuresTitle}
            >
                {title}
            </h4>
            <ul
                className={styles.featureList}
            >
                {items.map((feature, index) => (
                    <li 
                        key={index} 
                        className={styles.featureItem}
                    >
                        {feature}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default ProjectFeatures;